// extracted by mini-css-extract-plugin
module.exports = {"switch":"_1m4UKXbGzesICD53-qWXZT","lever":"_2nkHPBkFxz70Wxh8OQuauL"};